"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadDsnCfbPayloadIndex = void 0;
function buildSpans(records) {
    const events = new Map();
    for (const record of records) {
        if (record.payloadByteLength <= 0) {
            continue;
        }
        const end = record.offset + record.payloadByteLength;
        const opening = events.get(record.offset) ?? { starts: [], ends: [] };
        opening.starts.push(record);
        events.set(record.offset, opening);
        const closing = events.get(end) ?? { starts: [], ends: [] };
        closing.ends.push(record);
        events.set(end, closing);
    }
    const points = [...events].sort(([left], [right]) => left - right);
    const active = new Set();
    const spans = [];
    for (let index = 0; index + 1 < points.length; index++) {
        const [start, event] = points[index];
        for (const record of event.ends) {
            active.delete(record);
        }
        for (const record of event.starts) {
            active.add(record);
        }
        spans.push({
            start,
            end: points[index + 1][0],
            record: active.size === 1 ? [...active][0] : undefined,
        });
    }
    return spans;
}
class OrcadDsnCfbPayloadIndex {
    constructor(records) {
        this.records = new Map();
        const snapshot = records.map((record) => Object.freeze({ ...record }));
        const duplicateOffsets = new Set();
        for (const record of snapshot) {
            if (this.records.has(record.offset)) {
                duplicateOffsets.add(record.offset);
            }
            else {
                this.records.set(record.offset, record);
            }
        }
        for (const offset of duplicateOffsets) {
            this.records.delete(offset);
        }
        this.spans = buildSpans(snapshot);
    }
    get(offset) {
        return this.records.get(offset);
    }
    findUniqueContainingPayload(offset) {
        let low = 0;
        let high = this.spans.length;
        while (low < high) {
            const middle = Math.floor((low + high) / 2);
            if (this.spans[middle].start <= offset) {
                low = middle + 1;
            }
            else {
                high = middle;
            }
        }
        const span = this.spans[low - 1];
        return span !== undefined && offset < span.end ? span.record : undefined;
    }
}
exports.OrcadDsnCfbPayloadIndex = OrcadDsnCfbPayloadIndex;
//# sourceMappingURL=OrcadDsnCfbPayloadIndex.js.map